import { Flex, Text, Tooltip, TooltipProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { IoInformationCircle } from '@/components/common/Icons/IoInformationCircle';

interface LabelProps {
  name?: string;
  label?: string;
  secondaryLabel?: string;
  labelFontSize?: number | string;
  showTooltipIcon?: boolean;
  tooltipLabel?: string;
  tooltipProps?: Omit<TooltipProps, 'children'>;
  required?: boolean;
}

const Label = ({
  name,
  label,
  secondaryLabel,
  labelFontSize = 'sm',
  showTooltipIcon,
  tooltipLabel,
  tooltipProps,
  required = false,
}: LabelProps) => {
  const CustomLabel = ({ children }: { children: ReactNode }) => (
    <Flex gap={1} alignItems={'center'}>
      <Text fontWeight={'bold'} fontSize={labelFontSize}>
        {children}
      </Text>
      {required && (
        <Text color='red.500' display={'inline-block'} lineHeight={1.2}>
          *
        </Text>
      )}
    </Flex>
  );

  return typeof label === 'string' ? (
    label ? (
      <Flex alignItems={'center'}>
        <label htmlFor={name}>
          <CustomLabel>{label}</CustomLabel>
        </label>

        {secondaryLabel && (
          <label htmlFor={name}>
            <Text fontSize={'xs'} fontWeight={'medium'} color={'gray.400'}>
              &nbsp;{secondaryLabel}
            </Text>
          </label>
        )}
        {showTooltipIcon && (
          <Tooltip
            label={tooltipLabel}
            placement='top'
            hasArrow
            textAlign='center'
            backgroundColor='gray.900'
            {...tooltipProps}
            maxWidth='60'
            width='auto'
          >
            <IoInformationCircle ml={1} />
          </Tooltip>
        )}
      </Flex>
    ) : (
      <label htmlFor={name}>
        <CustomLabel>&nbsp;</CustomLabel>
      </label>
    )
  ) : null;
};

export default Label;
